var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._m(0),_c('div',{staticStyle:{"padding-left":"80px"},domProps:{"innerHTML":_vm._s(_vm.htmlData)}})])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h2',[_vm._v("开发服务器列表")]),_c('br'),_c('hr'),_c('br')])
}]

export { render, staticRenderFns }